import { useEffect, useRef } from "react";
import { useEventListener, useInterval } from "usehooks-ts";
import useUtilsBroadcaster from "../useUtilsBroadcaster";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TEST_MODE } from "../../components/common/consts";
import { errorToast } from "../../components/mui/Toaster";
import {
  ENUM_STATUS_WINDOW,
  setBroadcasterProfile,
  setIsAnonymity,
  setSendValue,
  setSettingInfo,
  setStatusWindow,
} from "../../store/chatSlice";
import { testSettingChat } from "../../testConst";
import { useDispatch } from "react-redux";
import { API_BROADCASTER } from "../../api/broadcasters";
import useDetectKeyboardOpen from "use-detect-keyboard-open";
import { scrollToElement } from "../../utils/utils";
import { ENUM_ELEMENT_NAME } from "../../components/common/enums";
import { useAppSelector } from "../../store/index.ts";

export default function useBroadcaster() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isKeyboardOpen = useDetectKeyboardOpen();

  const broadcasterId = useAppSelector((state) => state.chat.broadcaster.id);
  const userId = useAppSelector((state) => state.user.user.id);
  const statusWindow = useAppSelector((state) => state.chat.statusWindow);
  const isFullScreen = useAppSelector((state) => state.common.flags.foolScreen);

  const oldStateRef = useRef(); //старый режим чата
  const oldIsKeyboardOpenRef = useRef(); // старое состояние клавиатуры

  const { updateBroadcaster } = useUtilsBroadcaster();
  const doUpdateBroadcaster = () => {
    updateBroadcaster()
      .then((e) => {
        if (!e.ok) {
          if (TEST_MODE) return;
          navigate("/");
          errorToast(t(e.message));
        }
      })
      .catch(() => {
        if (TEST_MODE) return;
        navigate("/");
        errorToast(t("unknown error"));
      });
  };

  useEffect(() => {
    if (!broadcasterId) {
      dispatch(setSendValue(""));
      dispatch(setIsAnonymity(false));
      return;
    }

    if (TEST_MODE) dispatch(setSettingInfo(testSettingChat));
  }, [broadcasterId]);

  useEffect(() => {
    if (!broadcasterId) return;
    API_BROADCASTER.getProfile(broadcasterId)
      .then((e) => {
        const profile = e.data?.profile;
        if (profile) {
          dispatch(setBroadcasterProfile(profile));
        }
      })
      .catch(console.log);
  }, [broadcasterId, userId]);

  useEffect(() => {
    doUpdateBroadcaster();
  }, []);

  useEffect(() => {
    if (statusWindow === ENUM_STATUS_WINDOW.offline) return;
    oldStateRef.current = statusWindow;
  }, [statusWindow]);

  useEffect(() => {
    if (statusWindow === ENUM_STATUS_WINDOW.stream) return;
    if (isFullScreen) document?.exitFullscreen?.();
  }, [statusWindow, isFullScreen]);

  useEventListener("online", () => {
    if (!oldStateRef.current) return;
    console.log("ONLINE");

    console.log("status", oldStateRef.current);
    dispatch(setStatusWindow(oldStateRef.current));
  });

  useEffect(() => {
    if (oldIsKeyboardOpenRef.current && !isKeyboardOpen) {
      scrollToElement(ENUM_ELEMENT_NAME.chatPageHeader);
    }

    oldIsKeyboardOpenRef.current = isKeyboardOpen;
  }, [isKeyboardOpen]);

  useInterval(() => {
    updateBroadcaster();
  }, 60 * 1000);
}
